import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_cutoff_date_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  finance_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  finance_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  approval_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_day_count: fromDatatype.NumericDatatypeInterface;
  extension_date_logic: fromDatatype.VarcharDatatypeInterface;
  extension_day_of_month: fromDatatype.NumericDatatypeInterface;
  extension_day_count: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_cutoff_date_RowClass implements bl_aat_claim_cycle_cutoff_date_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  finance_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  finance_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  approval_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_day_count: fromDatatype.NumericDatatypeInterface;
  extension_date_logic: fromDatatype.VarcharDatatypeInterface;
  extension_day_of_month: fromDatatype.NumericDatatypeInterface;
  extension_day_count: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
